import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import './App.css';

import Dashboard from './pages/Dashboard';
import DashboardPage from './pages/DashboardPage';
import LoginAdmin from './pages/LoginAdmin';

import ChatPage from './pages/ChatPage';
import ChatVercelPage from './pages/ChatVercelPage';
import UserChatHome from './pages/UserChatHome';
import VoiceChatPage from './pages/VoiceChatPage';
import UserPricelistTemplatePage from './pages/UserPricelistTemplatePage';
import UserExaminationTemplatePage from './pages/UserExaminationTemplatePage';
import ProfilePage from './pages/ProfilePage';
import SettingPage from './pages/SettingPage';
import HistoryPage from './pages/HistoryPage';
import PricePage from './pages/PricePage';
import CategoryArticlePage from './pages/CategoryArticlePage';
import UserPricePage from './pages/UserPricePage';
import UserArticlePage from './pages/UserArticlePage';
import UserManagePage from './pages/UserManagePage';
import DokumenManagePage from './pages/DokumenManagePage';
import DokumenChunkVerificationPage from './pages/DokumenChunkVerificationPage';
import QdrantVectorPage from './pages/QdrantVectorPage';
import ArticleManagePage from './pages/ArticleManagePage';
import LlamaApiKeyManagePage from './pages/LlamaApiKeyManagePage';
import LogIngestManagePage from './pages/LogIngestManagePage';
import RagasEvaluationPage from './pages/RagasEvaluationPage';
import ConfirmationPage from './pages/payment/ConfirmationPage';
import TransactionManagePage from './pages/TransactionManagePage';
import ExaminationAssistantPage from './pages/ExaminationAssistantPage';
import OcrTestPage from './pages/OcrTestPage';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchLoginStatus = async () => {
    try {
      const res = await fetch(process.env.REACT_APP_API_BASE_URL+'/auth/check-login', {
        credentials: 'include'
      });
      const data = await res.json();
      setUser(data.loggedIn ? data.user : null);
    } catch (err) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLoginStatus();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }}>
        <img
          src="https://i.gifer.com/ZZ5H.gif "
          alt="Loading..."
          style={{ width: '80px', height: '80px' }}
        />
        <p style={{ marginTop: '10px', fontSize: '16px', color: '#555' }}>Checking session...</p>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            user?.role === 'ADMIN'
              ? <Navigate to="/dashboard" replace />
              : <UserChatHome user={user} setUser={setUser} />
          }
        />
        <Route
          path="/login/user"
          element={<Navigate to="/" replace />}
        />
        <Route
          path="/login/admin"
          element={
            user
              ? <Navigate to={user.role === 'ADMIN' ? '/dashboard' : '/'} replace />
              : <LoginAdmin setUser={setUser} />
          }
        />
        <Route path="/chat" element={<UserChatHome user={user} setUser={setUser} />} />
        <Route path="/chat/:sessionId" element={<UserChatHome user={user} setUser={setUser} />} />
        <Route path="/chat/voice" element={<VoiceChatPage />} />
        <Route
          path="/dashboard/pricelist"
          element={user?.role === 'USER' ? <UserPricelistTemplatePage /> : <Navigate to="/" replace />}
        />
        <Route
          path="/dashboard/examination-assistant"
          element={user?.role === 'USER' ? <UserExaminationTemplatePage /> : <Navigate to="/" replace />}
        />

        <Route path="/chatV" element={<ChatVercelPage />} />

        <Route
          path="/dashboard/*"
          element={user ? <Dashboard user={user} setUser={setUser} /> : <Navigate to="/" replace />}
        >
          <Route index element={<DashboardPage user={user} />} />

          <Route path="chat" element={<ChatPage />} />
          <Route path="chat/:sessionId" element={<ChatPage />} />
          <Route path="profile" element={<ProfilePage user={user} />} />

          {user?.role === 'ADMIN' && (
            <>
              <Route path="manage/document" element={<DokumenManagePage />} />
              <Route path="manage/document/:documentId/chunks" element={<DokumenChunkVerificationPage />} />
              <Route path="manage/document/:documentId/qdrant" element={<QdrantVectorPage />} />
              <Route path="manage/llama-api-key" element={<LlamaApiKeyManagePage />} />
              <Route path="manage/log-ingest" element={<LogIngestManagePage />} />
              <Route path="manage/ragas-evaluation" element={<RagasEvaluationPage />} />
              <Route path="manage/users" element={<UserManagePage />} />
              <Route path="manage/setting" element={<SettingPage />} />
              <Route path="manage/chat" element={<HistoryPage />} />
              <Route path="manage/pricelist" element={<PricePage />} />
              <Route path="manage/category-article" element={<CategoryArticlePage />} />
              <Route path="manage/article" element={<ArticleManagePage />} />
              <Route path="manage/transaction" element={<TransactionManagePage />} />
              <Route path="manage/ocr" element={<OcrTestPage />} />
            </>
          )}

          {user?.role === 'USER' && (
            <>
              <Route path="examination-assistant" element={<ExaminationAssistantPage />} />
              <Route path="pricelist" element={<UserPricePage />} />
              <Route path="confirm-package" element={<ConfirmationPage />} />
              <Route path="articles" element={<UserArticlePage />} />
            </>
          )}
          {/* <Route path="pricelist" element={<PricelistPage />} />
          <Route path="articles" element={<ArticlesPage />} />

          {user?.role === 'ADMIN' && (
            <>
              <Route path="users" element={<UsersPage />} />
              <Route path="documents" element={<DocumentsPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </>
          )} */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
